/* eslint-disable no-use-before-define */
import React from 'react'

export const Head = () => {
    return <thead>
        <tr>
        <th className="text-body">Order</th>
        <th className="text-body text-center" style={{width:'70px'}}>Action</th>
        <th className="text-body">Status</th>
        <th className="text-body">Time (ET)</th>
        <th className="text-body">Trans</th>
        <th className="text-body">Qty</th>
        <th className="text-body" style={{maxWidth:'250px'}}>Issue</th>
        <th className="text-body">CUSIP</th>
        <th className="text-body"><div>Coupon/</div><div>Maturity</div></th>
        <th className="text-body text-right">Price/Yield</th>
        <th className="text-body">Acct No</th>
        <th className="text-body">Contact</th>
        <th className="text-body text-right">Net Money</th>
        </tr>
    </thead>
}



// WEBPACK FOOTER //
// ./src/orders/blotter/head.js